import React, { useRef , useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';
import { addCustomerUploadData, fetchSubClientData } from '../../../services/client/customerApiService';
import { fetchVerficationTypeData } from '../../../services/client/verificationTypeApiService'; // Adjust the path as necessary
import { fetchServiceTypeData, downloadTitlesExcel } from '../../../services/client/serviceTypeApiService'; // Adjust the path as necessary
import CustomNotification from '../../common/CustomNotification';
const FileUploadForm = () => {
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [downloading, setDownloading] = useState(null);
    const [statusMessage, setStatusMessage] = useState("");
    const [subClients, setSubClients] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [componentList, setComponentList] = useState([]);
    const [details, setDetails] = useState("Dynamic content goes here!");

    const togglePopup = () => {
        setShowPopup(!showPopup);
    };
    const [formValues, setFormValues] = useState({
        serviceTypeId: '',
        subClientId: '',
        file: null,
    });
    const [inputKey, setInputKey] = useState(Date.now()); // Key for re-rendering
    const [errors, setErrors] = useState({});
    const inputClasses = (field) =>
        errors[field] ? 'border-red-500' : 'border-gray-300';

    const navigate = useNavigate(); // Initialize useNavigate
    useEffect(() => {
        const fetchServiceTypeByClient = async (clientId) => {
            try {
                const data = await fetchServiceTypeData(localStorage.getItem('clientID'));
                setServiceTypes(data.map(obj => ({ value: obj.serviceTypeId, label: obj.serviceType })));
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        fetchServiceTypeByClient();
    }, []);
    // Fetch sub-client data on mount
    useEffect(() => {
        const getSubClients = async () => {
            try {
                const subClientData = await fetchSubClientData(localStorage.getItem('clientID'));
                setSubClients(
                    subClientData.map(subClient => ({
                        value: subClient.subClientId,
                        label: subClient.subClientName,
                    }))
                );
            } catch (error) {
                console.error("Error fetching sub-clients:", error);
            }
        };
        getSubClients();
    }, []);

    // Validation function
    const validate = () => {
        const newErrors = {};
        if (!formValues.serviceTypeId) newErrors.serviceTypeId = 'Service Type is required';
        if (!formValues.subClientId) newErrors.subClientId = 'Client is required';
        if (!formValues.file) newErrors.file = 'File is required';
        return newErrors;
    };

    // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const fileInputRef = useRef(null);

const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
        const selectedFile = e.target.files[0];
        setFormValues((prev) => ({ ...prev, file: selectedFile }));
 // Reset the input value to allow selecting the same file again
 //e.target.value = null;
    }
};

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                // Prepare form data for submission
                const formData = new FormData();
                formData.append('subClientId', formValues.subClientId);
                formData.append('serviceTypeId', formValues.serviceTypeId);
                formData.append('file', formValues.file);
                formData.append('userId', localStorage.getItem('userID'));

                // Log FormData key-value pairs
               /* for (let [key, value] of formData.entries()) {
                    //console.log(`${key}:`, value);
                }*/

                // Simulate API response (Replace with actual API call)
                const response = await addCustomerUploadData(formData);//{ success: "File uploaded successfully!" };

                setApiResponse(response);
                if (!response.error) {
                    resetFormValues();
                }
            } catch (error) {
                console.error("Submission failed:", error);
                setApiResponse({ error: 'Failed to submit form. Please try again.' });
            } finally {
                setLoading(false);
                setErrors(validationErrors);
                setFormValues((prev) => ({ ...prev, file: null }));
                if (fileInputRef.current) {
                    fileInputRef.current.value = ""; // Reset file input
                }
            }
        } else {
            setErrors(validationErrors);
        }
    };

    // Reset form values
    const resetFormValues = () => {
        setFormValues({
            serviceTypeId: '',
            subClientId: '',
            file: null,
        });
        // Reset the file input field
   // Reset the file input field visually
   if (fileInputRef.current) {
    fileInputRef.current.value = ""; // Reset file input
}

// Force re-render to allow re-selection of the same file
setInputKey(Date.now());
        setErrors({});
    };

    // Handle form cancel
    const handleCancel = () => {
        resetFormValues();
        navigate('/fileUpload');
    };

    // Fetch data when icon is clicked
    const getComponentData = async () => {
        try {
            const clientId = localStorage.getItem('clientID');
            const data = await fetchVerficationTypeData(clientId); // Your API fetch function
            const options = data.map((verificationType) => ({
                id: verificationType.verificationTypeId,
                verificationType: verificationType.verificationType,
                verificationCode: verificationType.verificationCode,
                clientId: verificationType.clientId,
                clientName: verificationType.clientName,
                createdAt: verificationType.createdAt,
            }));
            setComponentList(options);
            setShowPopup(true); // Show popup once data is loaded
        } catch (error) {
            console.error("Error fetching verification types:", error);
        }
    };

    const handleDownload = async () => {
        try {
            setDownloading(true); // Show loading spinner

            await downloadTitlesExcel(formValues.serviceTypeId, "MIS Template");

        } catch (error) {
            console.error('Error fetching client data:', error);
        } finally {
            setDownloading(false); // Hide loading spinner
        }
    };

    const closeNotification = () => {
        setApiResponse(null);
    };

    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <form onSubmit={handleSubmit} className="space-y-6 w-full">
                <div>
                    <div class="grid grid-cols-10 gap-4">
                        <h1 class="col-span-7">MIS UPLOAD</h1>
                        <div class="col-span-3">
                            <button type='button' onClick={getComponentData} className="text-blue-500 hover:text-blue-700">
                                <FaExclamationCircle className="mr-2" />
                            </button>

                            {/* Popup with Table */}
                            {showPopup && (
                                <div className="absolute right-0 mt-2 w-96 p-4 bg-white rounded-lg shadow-lg border border-gray-200">
                                    <h3 className="text-lg font-semibold mb-2">Component Details</h3>
                                    <table className="w-full border-collapse border border-gray-300">
                                        <thead>
                                            <tr>
                                                <th className="border px-2 py-1">Component</th>
                                                <th className="border px-2 py-1">Code</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {componentList.map((item) => (
                                                <tr key={item.id}>
                                                    <td className="border px-2 py-1">{item.verificationType}</td>
                                                    <td className="border px-2 py-1">{item.verificationCode}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <button
                                        onClick={() => setShowPopup(false)}
                                        className="mt-4 text-sm text-blue-500 hover:text-blue-700"
                                    >
                                        Close
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6">
                        <div className="">
                            <>
                                {loading ? (
                                    <p>Loading ServiceTypes...</p>
                                ) : (


                                    <FloatingLabelSelect
                                        label="Select serviceType"
                                        id="serviceTypeId"
                                        name="serviceTypeId"
                                        value={serviceTypes.find(st => st.value === formValues.serviceTypeId) || null}
                                        onChange={(option) => setFormValues({ ...formValues, serviceTypeId: option.value })}
                                        className={inputClasses('serviceTypeId')}
                                        options={serviceTypes}
                                        isSearchable={true}
                                    />


                                )}
                            </>
                            {errors.serviceTypeId && <div className="text-red-500">{errors.serviceTypeId}</div>}
                        </div>
                        <div> {formValues?.serviceTypeId && (<button type='button' className='bg-blue-500 text-white px-2 py-1 rounded mr-2' onClick={() => handleDownload()}> {downloading ? 'Downloading...' : 'Download MIS Template'}</button>)}</div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6">
                        <FloatingLabelSelect
                            label="Select Client"
                            id="subClientId"
                            name="subClientId"
                            value={subClients.find(subClient => subClient.value === formValues.subClientId) || null}
                            onChange={(option) => setFormValues({ ...formValues, subClientId: option.value })}
                            className={errors.subClientId ? 'border-red-500' : 'border-gray-300'}
                            options={subClients}
                            isSearchable={true}
                        />
                        {errors.subClientId && (
                            <div className="text-red-500 text-sm">{errors.subClientId}</div>
                        )}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-6">
                        <div className="flex flex-col items-start space-y-2">
                            <label htmlFor="file" className="text-lg font-semibold text-gray-700">Upload File</label>
                            <input
                                type="file"
                                id="file"
                                name="file"
                                onChange={handleFileChange}
                                className={`p-3 border-2 rounded-md ${errors.file ? 'border-red-500' : 'border-gray-300'} focus:outline-none focus:ring-2 focus:ring-indigo-500`}
                                //key={formValues.file ? formValues.file.name : 'reset'}
                                ref={fileInputRef}
                key={inputKey} // Force React to re-mount input
                            />
                            {errors.file && (
                                <div className="text-red-500 text-sm mt-1">{errors.file}</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex gap-4">
                    <button
                        type="submit"
                        className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading ? 'opacity-50' : ''}`}
                        disabled={loading}
                    >
                        {loading ? 'Submitting...' : 'Submit'}
                    </button>
                    <button
                        type="button"
                        onClick={handleCancel}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                    >
                        Cancel
                    </button>
                </div>

                {/* {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : (
                            <>
                                <FaCheckCircle className="mr-2" />
                                {apiResponse.success}
                            </>
                        )}
                    </motion.div>
                )} */}
                {apiResponse && (
                    apiResponse.error ? (
                        <motion.div
                            className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <FaExclamationCircle className="mr-2" />
                            {apiResponse.error}
                        </motion.div>
                    ) : (
                        <CustomNotification
                            autoClose={true}
                            id={1}
                            message={apiResponse.success}
                            type={'success'}
                            onClose={closeNotification}
                        />
                    )
                )}
            </form>
        </div>
    );
};

export default FileUploadForm;

export const TestPage = () => {
    return (
        <div>
            <FileUploadForm />
        </div>
    );
};
